<template>
    <div class="password-issues-container">
        <ul>
            <li
                v-for="error in errors"
                :key="error"
                class="has-text-danger">
                {{ error }}
            </li>
        </ul>
    </div>
</template>

<script>

export default {
  name: "FormIssues",
  props: {
    errors: {
      type: Array,
      required: true
    }
  }
};

</script>

<style scoped>

li {
    list-style-type: disc;
}

ul {
    padding-left: 20px;
}

.password-issues-container {
    margin-bottom: 12px;
}

</style>